import React from "react";
import { Box, Card, useTheme, Skeleton } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

import AvatarList from "../../AvatarList";
import CustomCircleButton from "../../CustomCircleButton";

const TableLoadingCarts = () => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        border: "2px solid",
        borderColor: "black.main",
        boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
        borderRadius: "16px",
        height: "auto",
        marginBottom: "24px",
        cursor: "pointer",
      }}
    >
      <Skeleton variant='rounded' width={"100%"} height={226} />

      <Box
        sx={{
          padding: "16px",
          width: "100%",
        }}
      >
        {/* <Box
          sx={{
            mt: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
            mb: "12px",
          }}
        >
          <Skeleton width={50} height={15} />

          <Skeleton width={70} height={15} />
        </Box> */}
        <Skeleton
          sx={{
            mb: "6px",
          }}
          width={"75%"}
          height={38}
        />

        <Skeleton width={"100%"} height={15} />

        <Box
          sx={{
            borderTop: "2px solid",
            borderColor: "black.main",
            marginTop: "16px",
            paddingTop: "8px",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <AvatarList size={24} />

            <Box sx={{ textAlign: "right" }}>
              <CustomCircleButton
                width='26px'
                height='26px'
                bgColor='primary.main'
                color='black'
                hoverBgColor='black.main'
                hoverColor='white.main'
                activeBgColor='black.main'
                activeColor='white.main'
                bShadow={`0px 2px 0px ${theme.palette.black.main}`}
              >
                <AddRoundedIcon sx={{ fontSize: "20px" }} />
              </CustomCircleButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
export default TableLoadingCarts;
